import DeliveryNotice from './DeliveryNotice';
const prefix = "/area/soci";

export const rootPath = prefix + "/delivery-notice/:id?";

export const deliveryNoticeRoute = { path: rootPath, component: DeliveryNotice }
